import React from "react";
import './AboutSection.css'
import heroImg from "../../imgs/img-04.jpg";

/**
 * AboutSection
 * Two-column hero-like section
 * Left: Photo with profile tag + star rating overlay
 * Right: Eyebrow, Big Headline, Paragraph, CTA button
 */
export default function AboutSection({
  imageSrc = heroImg,
  eyebrow = "ABOUT ME",
  heading = "Crafting Solutions with Care and Expertise",
  body = (
    <>
      I believe that every home deserves to be treated with respect, and every client deserves honesty, reliability, and craftsmanship they can count on.
      Whether it's a small repair or a larger renovation, I approach each task with the same level of dedication and passion.<br/><br/>
      At the end of the day, this isn't just a business—it's a commitment to helping people feel more comfortable, confident, and happy in their homes.
      If you're looking for a handyman who values quality, takes pride in the details, and truly cares about your satisfaction, I'd be honored to work with you.
    </>
  ),
}) {
  return (
    <section id="about" className="about">
      <div className="inner">
        {/* Left: image with overlays */}
        <figure className="media">
          <img src={imageSrc} alt="Handyman at work" className="photo" />

          {/* Combined profile and review */}
          <div className="reviewCard">
            <img className="avatar" src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?q=80&w=120&auto=format&fit=crop" alt="Happy customer"/>
            <div className="meta">
              <div className="name">Jane Smith</div>
              <div className="role">"Absolutely fantastic service! Professional, quick, and attention to detail was top-notch."</div>
              <div className="stars">
                {Array.from({ length: 5 }).map((_, i) => (
                  <svg key={i} viewBox="0 0 24 24" width="18" height="18" aria-hidden>
                    <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.46 4.73L5.82 21 12 17.27Z" fill="#ff9d00"/>
                  </svg>
                ))}
              </div>
            </div>
          </div>
        </figure>

        {/* Right: content */}
        <div className="content">
          <div className="eyebrow" aria-label="section-eyebrow">
            {(typeof eyebrow === 'string' && eyebrow.trim().length > 0) ? eyebrow : 'SPECIALIZED ALL-ROUNDER'}
          </div>
          <h3 className="title2">{heading}</h3>
          <p className="text2">{body}</p>
  
        </div>
      </div>



    </section>
  );
}